/**
 * Image utility functions
 */

import { STRAPI_URL } from '../api/base';
import { StrapiImage } from '../types/common';

/**
 * Get image URL from Strapi image object
 */
export function getImageUrl(image: StrapiImage | null): string {
  if (!image) return '';

  // If the URL is already absolute, return it
  if (image.url.startsWith('http')) {
    return image.url;
  }

  // Otherwise, construct the full URL
  return `${STRAPI_URL}${image.url}`;
}

/**
 * Check if an image has a valid URL
 */
export function hasValidImageUrl(image: StrapiImage | null): boolean {
  if (!image) return false;

  const url = getImageUrl(image);
  return Boolean(url && url.length > 0);
}

/**
 * Get image alt text
 */
export function getImageAlt(image: StrapiImage | null): string {
  return image?.alternativeText || image?.name || '';
}

/**
 * Test function to verify getImageUrl works correctly
 * This can be used for debugging
 */
export function testGetImageUrl() {
  const testImage: StrapiImage = {
    id: 1,
    name: 'core-value-icon.svg',
    url: '/uploads/core_value_icon_1717420bbd.svg',
    width: 55,
    height: 48,
    alternativeText: null,
    caption: null,
  };

  const result = getImageUrl(testImage);
  console.log('Test getImageUrl:', {
    input: testImage,
    output: result,
    expected: `${STRAPI_URL}/uploads/core_value_icon_1717420bbd.svg`,
  });

  return result;
}
